module.exports = __webpack_public_path__ + "static/media/qrCode.d804e9fe.svg";